import { render, staticRenderFns } from "./AuthForGame.vue?vue&type=template&id=0daa6fc7&scoped=true&"
import script from "./AuthForGame.vue?vue&type=script&lang=js&"
export * from "./AuthForGame.vue?vue&type=script&lang=js&"
import style0 from "./AuthForGame.vue?vue&type=style&index=0&id=0daa6fc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daa6fc7",
  null
  
)

export default component.exports